import React, { useCallback, useEffect, useState, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import CrossIcon from '@chronos/components/Icons/CrossIcon';
import Button from '@chronos/components/Button';
import Modal from '@chronos/components/Modal';
import Header from '../Header';
import InstallInstruction from './InstallInstruction';
import * as S from './styled';
import {
  setShowInstallPrompt,
  selectShowInstallPromptModal,
  setShowInstallPromptModal,
} from '../../slices/appSlice';

const InstallPromptTitle = (
  <S.InstallPromptTitle>
    <S.PromptBigText>Chronos is better on the app</S.PromptBigText>
    <S.PromptText>PWA light app wont take up space</S.PromptText>
  </S.InstallPromptTitle>
);

const InstallPromptButton = () => (
  <Button
    type="button"
    style={{ backgroundColor: '#f4f5f7' }}
  >
    Install
  </Button>
);

const mapState = (state) => ({
  showInstallPromptModal: selectShowInstallPromptModal(state),
});

const InstallPrompt = () => {
  const dispatch = useDispatch();
  const [isIOS, setIsIOS] = useState(null);
  const [isAndroid, setIsAndroid] = useState(null);
  const [isMac, setIsMac] = useState(null);
  const [isLinux, setIsLinux] = useState(null);
  const [isWindows, setIsWindows] = useState(null);
  const { showInstallPromptModal } = useSelector(mapState);

  useEffect(() => {
    const platform =
      navigator?.userAgentData?.platform || navigator?.platform || 'unknown';

    setIsIOS(
      [
        'iPad Simulator',
        'iPhone Simulator',
        'iPod Simulator',
        'iPad',
        'iPhone',
        'iPod',
      ].includes(platform) ||
        (navigator.userAgent.includes('Mac') && 'ontouchend' in document)
    );
    setIsAndroid(/(android)/i.test(navigator.userAgent));
    setIsMac(platform.toUpperCase().indexOf('MAC') >= 0);
    setIsLinux(platform.toUpperCase().indexOf('LINUX') >= 0);
    setIsWindows(platform.toUpperCase().indexOf('WIN') >= 0);
  }, []);

  const closeInstallPrompt = useCallback(() => {
    dispatch(setShowInstallPrompt(false));
    localStorage.setItem('installPromptHide', +new Date());
  }, []);

  const closeInstallPromptModal = useCallback(() => {
    dispatch(setShowInstallPromptModal(false));
    localStorage.setItem('installPromptHide', +new Date());
  }, []);

  const onClickInstallPrompt = useCallback(async () => {
    if (window.deferredPrompt) {
      window.deferredPrompt.prompt();
      // Wait for the user to respond to the prompt
      const { outcome } = await window.deferredPrompt.userChoice;
      // Optionally, send analytics event with outcome of user choice
      console.log(`User response to the install prompt: ${outcome}`);
      // We've used the prompt, and can't use it again, throw it away
      window.deferredPrompt = null;
      dispatch(setShowInstallPrompt(false));
      return null;
    }
    dispatch(setShowInstallPromptModal(true));
    // show modal
    return null;
  }, []);

  const installPromptIcons = useMemo(() => {
    return [
      {
        name: 'close',
        Icon: CrossIcon,
        size: ['24px', '24px'],
        callback: closeInstallPrompt,
        placement: 'left',
      },
      {
        name: 'installButton',
        Icon: InstallPromptButton,
        callback: onClickInstallPrompt,
        placement: 'right',
      },
    ];
  }, []);

  return (
    <S.InstallPrompt>
      <Header
        title={InstallPromptTitle}
        icons={installPromptIcons}
        isFixedHeight={false}
      />
      <Modal
        isOpen={showInstallPromptModal}
        handleClose={closeInstallPromptModal}
        handleSubmit={closeInstallPromptModal}
      >
        <InstallInstruction
          isIOS={isIOS}
          isAndroid={isAndroid}
          isMac={isMac}
          isLinux={isLinux}
          isWindows={isWindows}
        />
      </Modal>
    </S.InstallPrompt>
  );
};

InstallPrompt.propTypes = {};
InstallPrompt.defaultProps = {};

export default InstallPrompt;
